module.exports = __webpack_public_path__ + "img/em-tao-process-03.c4d5a401.jpeg";